import { signal, computed } from '@preact/signals-react';

export type Sidebar = {
    id: string;
    name: string;
};

export const sidebars = signal<Sidebar[]>([]);

export const hasOpenSidebars = computed(() => sidebars.value.length > 0);

export const sidebarVisible = signal(false);

export const addSidebar = (sidebar: Sidebar) => {
    if (!sidebars.value.some(t => t.id === sidebar.id)) {
        sidebars.value = [...sidebars.value, { ...sidebar }];
    }
};

export const removeSidebar = (id: string) => {
    sidebars.value = sidebars.value.filter(t => t.id !== id);
};

export const isSidebarOpen = (id: string) => sidebars.value.some(t => t.id === id);

export default {
    sidebars,
    hasOpenSidebars,
    sidebarVisible,
    addSidebar,
    removeSidebar,
    isSidebarOpen,
};